import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import moment from 'moment';
import Breadcrumb from '../common/atoms/Breadcrumb';
import SubHeading from '../common/atoms/SubHeading';
import { LAUNCH_MAILER_RELEASE_DATE, isWelcomeMailerAvailable, loadPrelaunchActive } from '../../constants/companyMailer';
import { dsButtonLink } from '../../utils/buttonStyles';
import MailerBuilder from './MailerBuilder';

const MailerPage = () => {
  const history = useHistory();
  const heading = useRef(null);
  const welcome = useLocation().pathname === '/welcome-mailer';
  const launchDate = sessionStorage.getItem('launch_date');
  const available = welcome ? isWelcomeMailerAvailable(launchDate) : moment(launchDate, [moment.ISO_8601, 'YYYY-M-D'], true).isSameOrAfter(moment(LAUNCH_MAILER_RELEASE_DATE));
  // The Welcome mailer lives in Pre Launch while pre-launch runs; Engagement holds its follow-ups from launch day, then the Welcome too.
  // ponytail: this and the sidebar each fetch the launch status once; share it through app state if that matters.
  const [prelaunch, setPrelaunch] = useState(null);
  useEffect(() => {
    if (!available) return undefined;
    let live = true;
    const role = (sessionStorage.getItem('role') || '').toLowerCase().replace(/ /g, '_');
    setPrelaunch(null);
    loadPrelaunchActive({ role, launchDate, isActive: sessionStorage.getItem('is_active') }, active => { if (live) setPrelaunch(active); });
    return () => { live = false; };
  }, [available, launchDate]);
  useEffect(() => {
    if (welcome && !available) history.replace('/overview');
  }, [available, history, welcome]);
  useEffect(() => { if (available && prelaunch !== null) heading.current?.focus(); }, [available, prelaunch, welcome]);
  const ended = !welcome && prelaunch === false;
  if (!available || ended) return welcome ? null : <section className="prelaunch-page font-sans">
    <div role="status" className="rounded-ds-lg border border-gray-300 bg-white p-6">
      <h1 className="mb-2 text-3xl font-semibold text-gray-800">Pre-launch mailers</h1>
      <p className="mb-4 text-gray-600">{ended ? 'Pre-launch mailers are no longer available. The Welcome mailer is in Engagement.' : 'Pre-launch mailers are not available for your company yet.'}</p>
      <button type="button" className={dsButtonLink} onClick={() => history.push('/overview')}>Go to overview</button>
    </div>
  </section>;
  if (prelaunch === null) return null;
  if (welcome) return <section className="prelaunch-page"><MailerBuilder types={['launch']} backPath="/welcome-mailer" prelaunch={prelaunch} /></section>;
  return <section className="prelaunch-page">
    <Breadcrumb list={[{ text: 'Pre-launch mailers' }]} classes="mb-2" />
    <h1 ref={heading} tabIndex={-1} className="mb-0 font-fig-extrabold text-3xl leading-tight text-gray-900 focus:outline-none">Pre-launch mailers</h1>
    <SubHeading subHeading="Prepare and publish emails for your company launch." />
    <MailerBuilder types={['teaser', 'pre_launch', 'launch']} backPath="/mailer" />
  </section>;
};

export default MailerPage;
